var borderDark = {
  "border": "0.0625rem solid #c8c9c7"
};

export { borderDark };
